import * as Mutations from '../../mutations';

export default {
  setPermissions({ commit }, permissions) {
    commit(Mutations.SET_PERMISSIONS, permissions);
  },
};
